// extracted by mini-css-extract-plugin
export default {"dialogRoot":"TicketSolutionDialog_dialogRoot__41BVF"};